import { Navigate, useLocation } from "react-router-dom";

export function PortfolioEntryRedirect({
  invite = false,
}: {
  invite?: boolean;
}) {
  const { search } = useLocation();
  const hasInviteCode = Boolean(
    new URLSearchParams(search).get("inviteCode")?.trim(),
  );
  return (
    <Navigate
      replace
      to={{
        pathname: `/portfolio/${invite || hasInviteCode ? "invite" : "assets"}`,
        search,
      }}
    />
  );
}
